import reduceReducers from 'reduce-reducers'

import {
  default as DetailReducer,
  initialState as DetailInitialState,
} from './detail'
import {
  default as CommonReducer,
  initialState as CommonInitialState,
  types as CommonTypes,
} from './common'

// Export all from individual files
export * from './detail'
export * from './common'

// Combined types
export const types = {
  // Common UI types
  ...CommonTypes,
}

// Combined initial state
export const initialState = {
  ...DetailInitialState,
  ...CommonInitialState,
}

// Combine reducers
export default reduceReducers(
  DetailReducer,
  CommonReducer,
  // the last arg MUST be the shared state
  initialState,
)
